import axios from "../../axios/AxiosInstance";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check, KeyRound, Loader2, Mail } from "lucide-react";
import "../LoginPage.css";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [askedPassword, setAskedPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const askPassword = async (event) => {
    event.preventDefault();
    if (loading) return;
    const login = username.trim();
    if (!login) {
      setError("Veuillez renseigner votre identifiant.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await axios.post("/auth/ask-reset-password-freelance", { username: login });
      setAskedPassword(true);
    } catch (e) {
      setError(e.response?.status === 404
        ? "Cet identifiant est introuvable. Vérifiez votre saisie."
        : "L’envoi n’a pas abouti. Vérifiez votre identifiant et réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="jm-login">
      <header className="jm-login-header">
        <a href="https://www.jm-interim.com/" className="jm-login-brand" aria-label="J’M Intérim, accueil"><img src="/brand/jm-interim-logo.jpg" alt="J’M Intérim — L’humain au cœur de nos missions" /></a>
        <Link to="/login" className="jm-login-back"><ArrowLeft size={16} aria-hidden="true" /> Connexion</Link>
      </header>
      <main className="jm-login-content">
        <section className="jm-login-access" aria-labelledby="reset-title" aria-busy={loading}>
          <div className="jm-login-card-heading"><span className="jm-login-symbol" aria-hidden="true">{askedPassword ? <Check size={22} /> : <KeyRound size={22} strokeWidth={1.6} />}</span><p className="jm-login-kicker">ESPACE RECRUTEUR</p></div>
          {askedPassword ? (
            <div role="status" aria-live="polite">
              <h1 id="reset-title">Consultez votre boîte mail<span>.</span></h1>
              <p className="jm-login-description">Un lien de réinitialisation vous a été envoyé. Suivez les instructions du message pour choisir votre nouveau mot de passe.</p>
              <p className="jm-login-recovery-note">Vous ne trouvez pas le message ? Pensez à vérifier vos courriers indésirables.</p>
              <Link to="/login" className="jm-login-submit">Retour à la connexion <ArrowRight size={18} aria-hidden="true" /></Link>
            </div>
          ) : (
            <>
              <h1 id="reset-title">Mot de passe oublié<span> ?</span></h1>
              <p className="jm-login-description">Renseignez votre identifiant de connexion. Nous vous enverrons un lien pour créer un nouveau mot de passe.</p>
              <form onSubmit={askPassword} className="jm-login-form">
                <div>
                  <label htmlFor="reset-username">Votre identifiant</label>
                  <div className="jm-login-input"><Mail size={19} aria-hidden="true" /><input id="reset-username" name="username" autoComplete="username" autoCapitalize="none" spellCheck={false} required value={username} onChange={event => { setUsername(event.target.value); setError(""); }} disabled={loading} placeholder="Votre identifiant de connexion" aria-invalid={Boolean(error)} aria-describedby={error ? "reset-error" : undefined} /></div>
                </div>
                {error && <p id="reset-error" role="alert" className="jm-login-error">{error}</p>}
                <button type="submit" disabled={loading} className="jm-login-submit">{loading ? <><span>Envoi en cours…</span><Loader2 size={18} className="animate-spin" aria-hidden="true" /></> : <><span>Envoyer le lien</span><ArrowRight size={18} aria-hidden="true" /></>}</button>
              </form>
              <Link to="/login" className="jm-login-recovery-back"><ArrowLeft size={16} aria-hidden="true" /> Retour à la connexion</Link>
            </>
          )}
        </section>
      </main>
      <footer className="jm-login-footer"><span>© {new Date().getFullYear()} J’M Intérim</span><span>L’humain au cœur de nos missions.</span><a href="https://www.jm-interim.com/contact">Contacter l’équipe</a></footer>
    </div>
  );
}
